"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var CheckOutline_1 = __importDefault(require("../icons/generated/CheckOutline"));
var RemoveOutline_1 = __importDefault(require("../icons/generated/RemoveOutline"));
var CheckboxContainer = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n"])));
CheckboxContainer.displayName = 'CheckboxContainer';
var Label = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n"], ["\n  color: ",
    ";\n  cursor: pointer;\n"])), function (_a) {
    var checkbox = _a.theme.colours.checkbox;
    return checkbox.color;
});
Label.displayName = 'Label';
function getCheckmarkBorderColor(color, behaviour) {
    if (behaviour.disabled) {
        return color.disabledColor;
    }
    return behaviour.state === 'unchecked' ? color.color : color.backgroundColor;
}
function getCheckmarkBackgroundColor(color, behaviour) {
    var state = behaviour.state, disabled = behaviour.disabled;
    var disabledColor = color.disabledColor, backgroundColor = color.backgroundColor;
    if (state === 'checked' || state === 'indeterminate')
        return disabled ? disabledColor : backgroundColor;
    return 'transparent';
}
var CheckMark = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  border: ", ";\n  margin-right: 8px;\n  background-color: ", ";\n\n  svg {\n    fill: ", ";\n  }\n"], ["\n  width: 16px;\n  height: 16px;\n  border: ",
    ";\n  margin-right: 8px;\n  background-color: ",
    ";\n\n  svg {\n    fill: ",
    ";\n  }\n"])), function (_a) {
    var state = _a.state, disabled = _a.disabled, checkbox = _a.theme.colours.checkbox;
    return "1px solid " + getCheckmarkBorderColor(checkbox, { state: state, disabled: disabled });
}, function (_a) {
    var state = _a.state, disabled = _a.disabled, checkbox = _a.theme.colours.checkbox;
    return getCheckmarkBackgroundColor(checkbox, { state: state, disabled: disabled });
}, function (_a) {
    var checkbox = _a.theme.colours.checkbox;
    return checkbox.color;
});
CheckMark.displayName = 'CheckMark';
var Checkbox = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, testID = _a.testID;
    return (react_1.default.createElement(CheckboxContainer, null,
        react_1.default.createElement(CheckMark, { onClick: onChange, state: value, disabled: disabled, "data-test-id": testID },
            value === 'checked' && react_1.default.createElement(CheckOutline_1.default, null),
            value === 'indeterminate' && react_1.default.createElement(RemoveOutline_1.default, null)),
        react_1.default.createElement(Label, { onClick: onChange }, label)));
};
Checkbox.displayName = 'Checkbox';
exports.default = Checkbox;
var templateObject_1, templateObject_2, templateObject_3;
